export const API_PATH_ApiDeviceMgmtRegionDelete = '/services/devices-mgtm/apiDeviceMgmtRegionDelete';
